<template>
  <div class="isTxt" v-if="isTxt">
    {{ !isNullOrUndefOrEmpty(innerValue) ? innerValue : '-' }}
  </div>
  <RxkInput
    v-else
    style="width: 100%"
    :modelValue="innerValue"
    :type="renderConfig.inputType"
    :disabled="renderConfig.disabled"
    :placeholder="renderConfig.placeholder"
    :show-word-limit="!renderConfig.hideWordLimit"
    @update:modalValue="handleInput"
    :minlength="data.minLength"
    :maxlength="data.maxLength || renderConfig.maxlength"
    @blur="handleBlur"
  >
    <template #suffix v-if="data.code === fieldTypeConfig.percentage">
      <span v-if="!renderConfig.hideUnit">{{ renderConfig.unit || '%' }}</span>
    </template>
  </RxkInput>
</template>
<script lang="ts" setup>
import { ref, computed, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkInput } from '@/components/common/RxkInput'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'blur'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    const trim = props.trim || props?.renderConfig?.trim
    emit('update:modelValue', trim ? newVal.replace(/\s+/g, '') : newVal)
  }
})

function handleBlur() {
  emit('blur', innerValue.value)
}

// 输入验证
function handleInput(val: string) {
  if (
    props.data.code === fieldTypeConfig.number ||
    props.data.code === fieldTypeConfig.percentage
  ) {
    innerValue.value = formatNumber(val, props.data)
  } else if (props.data.code === fieldTypeConfig.idCard) {
    innerValue.value = formatIdCard(val)
  } else {
    innerValue.value = val
  }
}

// 检验数字
function formatNumber(val: string, fieldOption: Record<string, any>) {
  let temp = val.toString()
  temp = temp.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
  temp = temp.replace(/^\./g, '') // 验证第一个字符是数字
  temp = temp.replace(/\.{2,}/g, '') // 只保留第一个., 清除多余的
  // 输入小数位数
  if (fieldOption.precisions) {
    const decimal = temp.split('.')[1]
    const integer = temp.split('.')[0]
    if (decimal) {
      temp = integer + '.' + decimal.substring(0, fieldOption.precisions)
    }
  } else {
    temp = temp.replace(/[^\d]/g, '')
  }
  return temp
}

// 校验身份证号  18位带Xx
function formatIdCard(val: string) {
  let temp = val.toString()
  temp = temp.replace(/[^\dXx]/g, '') // 清除"数字"和"x"以外的字符
  temp = temp.replace(/[a-zA-Z]{2,}/g, 'x') // 只保留第一个, 清除多余的
  // 18位
  if (temp.length > 18) {
    temp = temp.substring(0, 18)
  }
  // x只能是最后一位
  const xIndex = temp.indexOf('X') === -1 ? temp.indexOf('x') : temp.indexOf('X')
  if (xIndex > -1 && xIndex !== temp.length - 1) {
    temp = temp.replace(/[a-zA-Z]/g, '')
  }
  return temp
}

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>
